import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {
  SearchToggleButtonComponent
} from '../../component/search-filter-utils/search-toggle-button/search-toggle-button.component';
import {SHARED_IMPORTS} from '../../shared.imports';
import {InfoIconComponent} from '../../component/info-icon.component/info-icon.component';
import {ToggleSwitchComponent} from '../../component/toggle-switch/toggle-switch.component';
import {AccordionComponent} from '../../component/accordion/accordion.component';
import {PriceInputComponent} from '../../component/input/price-input/price-input.component';
import {DatepickerRangeComponent} from '../../component/range-datepicker/datepicker-range/datepicker-range.component';
import {DropzoneComponent} from '../../component/dropzone/dropzone.component';
import {NgxFloatUiPlacements, NgxFloatUiTriggers} from 'ngx-float-ui';
import {DropdownMenuComponent} from '../../component/dropdown-menu/dropdown-menu.component';
import {BasicDialogComponent} from '../../../standalone/basic-dialog/basic-dialog.component';

@Component({
  styles: `
      @import '../../../../scss/defaults.scss';
  `,
  imports: [
    ReactiveFormsModule,
    SearchToggleButtonComponent,
    SHARED_IMPORTS,
    InfoIconComponent,
    ToggleSwitchComponent,
    AccordionComponent,
    PriceInputComponent,
    DatepickerRangeComponent,
    DropzoneComponent,
    DropdownMenuComponent,
    BasicDialogComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './demo.component.html'
})
export class DemoComponent {
  protected readonly NgxFloatUiPlacements = NgxFloatUiPlacements;
  protected readonly NgxFloatUiTriggers = NgxFloatUiTriggers;
}
